export enum StorageConstants {
  SESSION = "DASHBOARD_SESSION",
  TOKEN = "DASHBOARD_TOKEN",
  BUSINESS = "DASHBOARD_BUSINESS",
  PERMISSION = "DASHBOARD_PERMISSIONS",
  LOCATIONS = "DASHBOARD_LOCATIONS",
  LEFT_SIDE = "IS_LEFT_SIDE_MINI",
  LANG = "LANG",
  CREDENTIALS = "LOGIN_CREDENTIALS",
  TABLE_STORE_SELECTED_COLS = "TABLE_STORE_SELECTED_COLS",
  PREVIEW_TRANSACTIONS_COLS = "PREVIEW_TRANSACTIONS_COLS",
  LEFT_SIDE_ONSCROLL = "LEFT_SIDE_ONSCROLL",
  FAILED_ORDERS_LIST = "FAILED_ORDERS_LIST",
  SELECTED_AGENT = "SELECTED_AGENT",
  OOC_SESSION = "OOC_SESSION",
  OOC_CREDENTIALS = "OOC_CREDENTIALS",
  OOC_TOKEN = "OOC_TOKEN",
  OOC_PERMISSION = "OOC_PERMISSION",
  NEXT_ROUTE = "NEXT_ROUTE",
  APP_STORAGE_VERSION = "APP_STORAGE_VERSION",
  CITIES = "CITIES",
}
